import {
  CustomSelect,
  SingleItemSelectedDefault,
  useCustomSelectStateFromInfiniteScrollProvider,
} from '../../../../components/inputs/CustomSelect'
import Workspace from 'iam/models/Workspace'
import { observer } from 'mobx-react'
import React from 'react'
import SearchResultItem from 'components/inputs/CustomSelect/SearchResultItem'
import FormRow from 'components/inputs/FormRow'
import { FormGroupContainer } from '../../../../components/inputs'
import { ISchemaBoundValidationContext } from 'validx'
import WorkspaceSelectorViewModel from '../../WorkspaceSelectorViewModel'
import Avatar from 'components/Avatar'

export interface IWithWorkspaceSelection {
  workspace?: Workspace
  workspaceSelectorVM: WorkspaceSelectorViewModel
  workspaceValidation: ISchemaBoundValidationContext<any>
  setWorkspace: (workspace?: Workspace) => void
}

interface Props {
  vm: IWithWorkspaceSelection
  workspaceSelectorVM: WorkspaceSelectorViewModel
}

export default observer(function InventoryItemFormWorkspaceDropdown({
  vm,
  workspaceSelectorVM,
}: Props) {
  const selectProps = useCustomSelectStateFromInfiniteScrollProvider({
    scrollProvider: workspaceSelectorVM.scrollProvider,
    searchText: workspaceSelectorVM.searchText,
    onSearchTextChange: workspaceSelectorVM.setSearchText,
    searchResults: workspaceSelectorVM.filteredWorkspaces,
  })

  return (
    <FormRow>
      <FormGroupContainer
        model={vm}
        field={'workspace'}
        label="Select workspace"
        error={vm.workspaceValidation.getError('workspace')}
      >
        <CustomSelect
          {...selectProps}
          placeholder="Select workspace"
          data-test="inventory-item-modal-workspace-dropdown"
          itemToString={(v) => String(v?.name)}
          value={vm.workspace}
          multi={false}
          onChange={vm.setWorkspace}
          renderItem={(itemProps) => (
            <SingleItemSelectedDefault
              {...itemProps}
              visual={
                <Avatar
                  size={24}
                  subject={{
                    displayName: itemProps.item.name,
                    avatar: itemProps.item.branding.logos.icon,
                  }}
                />
              }
            />
          )}
          renderSearchItem={({ item, itemToString, ...itemProps }) => (
            <SearchResultItem
              {...itemProps}
              data-test={'inventory-item-modal-workspace-' + item.name}
              visual={
                <Avatar
                  size={24}
                  subject={{
                    avatar: item.branding.logos.icon,
                    displayName: item.name,
                  }}
                />
              }
            >
              {item.name}
            </SearchResultItem>
          )}
        />
      </FormGroupContainer>
    </FormRow>
  )
})
